import "./style.moduleRenamed.css";

export const logPanel = "style-module__logPanel___x8A1A";

export default {
  logPanel: "style-module__logPanel___x8A1A",
};